export const ADD_NEW_CUSTOMER = "ADD_NEW_CUSTOMER";
export const GET_CUSTOMER = "GET_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const SEARCH_ON_CUSTOMER = "SEARCH_ON_CUSTOMER";
export const GET_ASSIGNMENT = "GET_ASSIGNMENT";
export const GET_ALL_ASSIGNMENT = "GET_ALL_ASSIGNMENT";
export const DELETE_ASSIGNMENT = "DELETE_ASSIGNMENT";
export const PUBLISH_ASSIGNMENT = "PUBLISH_ASSIGNMENT";
export const UNPUBLISH_ASSIGNMENT = "UNPUBLISH_ASSIGNMENT";
export const ADD_NEW_ASSIGNMENT = "ADD_NEW_ASSIGNMENT";
export const UPDATE_ASSIGNMENT = "UPDATE_ASSIGNMENT";
export const GET_CUSTOMER_BY_ID = "GET_CUSTOMER_BY_ID";
export const GET_ASSIGNMENT_BY_CUSTOMER_ID = "GET_ASSIGNMENT_BY_CUSTOMER_ID";
export const SEARCH_ASSIGNMENT = "SEARCH_ASSIGNMENT";
export const DELETE_CUSTOMER_ACCOUNT = "DELETE_CUSTOMER_ACCOUNT";
export const UPDATE_CUSTOMER_ACCOUNT_PASSWORD = "UPDATE_CUSTOMER_ACCOUNT_PASSWORD";

export const CUSTOMER_GET_MY_INTERNSHIPS = "CUSTOMER_GET_MY_INTERNSHIPS";
export const CUSTOMER_SAVE_INTERNSHIP = "CUSTOMER_SAVE_INTERNSHIP";
export const CUSTOMER_UPDATE_INTERNSHIP = "CUSTOMER_UPDATE_INTERNSHIP";
export const CUSTOMER_SEARCH_MY_INTERNSHIPS = "CUSTOMER_SEARCH_MY_INTERNSHIPS";
export const CUSTOMER_DELETE_INTERNSHIP = "CUSTOMER_DELETE_INTERNSHIP";
export const CUSTOMER_UNPUBLISH_INTERNSHIP = "CUSTOMER_UNPUBLISH_INTERNSHIP";
export const CUSTOMER_PUBLISH_INTERNSHIP = "CUSTOMER_PUBLISH_INTERNSHIP";
export const CUSTOMER_GET_PUBLIC_INTERNSHIP = "CUSTOMER_GET_PUBLIC_INTERNSHIP";
export const CUSTOMER_GET_MY_STUDENT = "CUSTOMER_GET_MY_STUDENT";
export const CUSTOMER_SEARCH_MY_STUDENT = "CUSTOMER_SEARCH_MY_STUDENT";
export const CUSTOMER_SELECT_STUDENT = "CUSTOMER_SELECT_STUDENT";
export const CUSTOMER_MAKE_STUDENT_INTERN = "CUSTOMER_MAKE_STUDENT_INTERN";
export const CUSTOMER_SEND_CONTRACT = "CUSTOMER_SEND_CONTRACT";
export const CUSTOMER_MARK_STUDENT_AS_STARTED = "CUSTOMER_MARK_STUDENT_AS_STARTED";
export const CUSTOMER_FILTER_INTERSHIP = "CUSTOMER_FILTER_INTERSHIP";
export const CUSTOMER_ATTACH_CONTRACT = "CUSTOMER_ATTACH_CONTRACT";
export const CUSTOMER_REMOVE_CONTRACT = "CUSTOMER_REMOVE_CONTRACT";
export const INTERNSHIP_GET_SINGLE = "INTERNSHIP_GET_SINGLE";